import { useLocation, Navigate } from "react-router-dom";
// material
import { styled } from '@mui/material/styles';
import { Stack, Container, Card, Typography } from '@mui/material';
// components
import Page from '../../../components/Page';
import ExecutiveExpenses from '../../../components/SidebarMenuComponents/MasterComponent/ExecutiveExpenses';
import StickyHeader from "../../../components/Common/StickyHeader";

// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
export default function ExecutiveExpensesPage() {
    const location = useLocation();
    const executiveExpenses = location.state;

    return (
        <Page title="Executive Expenses | tiketic" >
           
            <StickyHeader title="Executive Expenses" />

            <ContentStyle>
                <ExecutiveExpenses executiveExpenses={executiveExpenses} />
            </ContentStyle>
        </Page>
    );
}

